module.exports = __webpack_public_path__ + "img/76.9.TU.ef6aa369.png";